module.exports = __webpack_public_path__ + "img/guide_08.4bbecc91.png";